import React from 'react';
import Timesheets from './Timesheets';

const AdminTimeOff = () => {
  return <Timesheets initialTab="accruals" showAdminTabs={true} />;
};

export default AdminTimeOff;
